// src/pages/DataRequest.tsx
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import styles from './StaticPage.module.css';
import ReCAPTCHA from "react-google-recaptcha";

const DataRequest: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!captchaToken) {
      alert('Please complete the CAPTCHA before submitting.');
      return;
    }

    emailjs
      .send(
        'service_wzunfqr', // Your Service ID
        'template_0bsetst', // Your Template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        'U3OtEYyQxeUC4IXzn' // Your Public Key
      )
      .then(
        (response) => {
          alert('Your request has been submitted. Thank you!');
          setFormData({ name: '', email: '', message: '' });
          setCaptchaToken(null); // reset CAPTCHA after success
        },
        (error) => {
          console.error('Email send error:', error.text);
          alert('There was an error sending your request. Please try again later.');
        }
      );
  };

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>Data Request Form</h1>

      <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
        This form is for submitting data privacy requests or support inquiries related to your account.
        Please fill out the form below, and we will respond as soon as possible.
      </p>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
          style={{ padding: '10px', fontSize: '16px' }}
        />
        <input
          type="email"
          name="email"
          placeholder="Email (required)"
          value={formData.email}
          onChange={handleChange}
          required
          style={{ padding: '10px', fontSize: '16px' }}
        />
        <textarea
          name="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleChange}
          rows={6}
          required
          style={{ padding: '10px', fontSize: '16px' }}
        />

        {/* 🛡️ CAPTCHA FIELD */}
        <div style={{ alignSelf: 'center' }}>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
            onChange={(value) => setCaptchaToken(value)}
          />
        </div>

        <button
          type="submit"
          style={{
            padding: '12px',
            backgroundColor: '#4f6ef7',
            color: 'white',
            fontSize: '16px',
            fontWeight: 600,
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default DataRequest;
